import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, TextField } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';

import { logisticTasksPetrolResourceActions } from '../../../../../../entities/logistic/logisticTasks/redux/logisticTasksPetrol.slice';
import ActionBarDateTimePicker from '../../../../../../shared/ui/ActionBarDateTimePicker/ActionBarDateTimePicker';
import Container from './styles/Container';
import DateStack from './styles/DateStack';

export default function Header({ fastTaskName, onTaskNameChanged, rePlanDate, dispatch }) {
  return (
    <Container>
      <TextField
        onChange={(event) => onTaskNameChanged(event.target.value)}
        id="lat"
        label="Название"
        value={fastTaskName || ''}
        type="text"
        variant="outlined"
        sx={{ flexGrow: 1 }}
      />
      <Box>
        <DateStack>
          <DateTimePicker
            label="Начало маршрута, не ранее"
            onChange={(e) => {
              const isValidDate = e instanceof Date && !Number.isNaN(e.getTime());
              dispatch(logisticTasksPetrolResourceActions.setRePlanDate(isValidDate ? e.toISOString() : null));
            }}
            renderInput={(params) => (
              <TextField
                variant="standard"
                {...params}
                inputProps={{ ...params.inputProps, placeholder: 'дд.мм.гггг чч:мм' }}
                sx={{ minWidth: '260px' }}
              />
            )}
            components={{
              ActionBar: ActionBarDateTimePicker,
            }}
            value={rePlanDate}
          />
        </DateStack>
      </Box>
    </Container>
  );
}

Header.propTypes = {
  fastTaskName: PropTypes.string.isRequired,
  onTaskNameChanged: PropTypes.func.isRequired,
  rePlanDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  dispatch: PropTypes.func.isRequired,
};
